/**
 * Best-effort device position for an attendance check-in.
 *
 * Location sharing is optional: the server records the request IP regardless,
 * and a check-in must never be blocked because a device declined to share a
 * position or took too long to fix one. Every failure -- no geolocation API,
 * permission denied, timeout -- resolves to `null`, and the caller simply
 * checks in without coordinates.
 */
export interface PunchLocation {
  latitude: number;
  longitude: number;
  /** Horizontal accuracy in metres, as reported by the device. */
  accuracy?: number;
}

export function currentPosition(timeoutMs = 4000): Promise<PunchLocation | null> {
  if (typeof navigator === "undefined" || !navigator.geolocation) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 60_000 },
    );
  });
}
